import React from 'react';
import Icon from '../../Common/Icon';
import { AI_COACH_PATHS, HELP_TRUST_FACTS } from '../../../content/helpGuidanceContent';

const LandingAISection = React.memo(() => (
  <section id="ai" className="landing-ai-section">
    <div className="landing-template-frame landing-ai-frame">
      <div className="landing-ai-copy">
        <h2>One Coach. Two ways to begin.</h2>
        <p>Start in your own words or choose a focused guided session.</p>
        <div className="landing-editorial-rule" aria-hidden="true">
          <Icon name="sprout" size={23} />
          <span />
        </div>
      </div>

      <figure className="landing-ai-portrait">
        <img
          src="/landing/ai-coach-portrait.jpg"
          alt="Friendly coach in a calm setting"
          loading="lazy"
        />
      </figure>

      <div className="landing-ai-paths" aria-label="AI Coach entry paths">
        {AI_COACH_PATHS.map((path) => (
          <article className="landing-ai-path" key={path.title}>
            <span aria-hidden="true"><Icon name={path.icon} size={18} /></span>
            <div>
              <h3>{path.title}</h3>
              <p>{path.detail}</p>
            </div>
          </article>
        ))}
        <p className="landing-ai-control-note">
          <Icon name="shield-check" size={17} />
          <span>{HELP_TRUST_FACTS.coachControl} {HELP_TRUST_FACTS.manualPath}</span>
        </p>
        <p className="landing-sr-only">
          AI Coach is coaching, not therapy. For mental-health concerns, contact a qualified professional. If you are at risk or in crisis, contact emergency or crisis services.
        </p>
      </div>
    </div>
  </section>
));

LandingAISection.displayName = 'LandingAISection';

export default LandingAISection;
